import React from "react";

import Loader from "./loader";
import StickyHeaderDataTable from "./shared/sticky-header-data-table";

const DataTableServerPagination = (props) => {
  const tableData = {
    columns: props.columns,
    data: props?.data?.length ? props.data : [],
  };

  return (
    <div className="server-pagination-table-container">
      <StickyHeaderDataTable
        data={tableData.data}
        columns={tableData.columns}
        selectableRows={props.disableSelection ? false : true}
        noHeader
        key="dataTable-server-pagination"
        // rowKey="_id"
        // key={JSON.stringify(tableData.data)}
        highlightOnHover
        pagination={props.hideFooter ? false : true}
        paginationServer
        paginationPerPage={props.state.countPerPage}
        paginationRowsPerPageOptions={[25, 50, 100, 150, 200, 250, 500]}
        onChangePage={props.handlePageChange}
        onChangeRowsPerPage={props.handleRowsPerPageChange}
        paginationTotalRows={props.state.totalLength}
        onSelectedRowsChange={props.onSelection}
        clearSelectedRows={props.state.clearSelectedRows}
        paginationDefaultPage={props.state.currentPage}
        responsive={true}
        defaultSortField={props.defaultSortField}
        defaultSortAsc={props.defaultSortAsc}
        selectableRowSelected={props.selectableRowSelected}
        onSort={props.handleSort}
        sortServer={props.sortServer}
        progressPending={props.progressPending}
        keyField={"_id"}
        progressComponent={<Loader />}
        persistTableHead={props.persistTableHead}
        selectableRowsHighlight
        className="server-pagination-table"
        onRowClicked={props.onRowClicked}
      ></StickyHeaderDataTable>
    </div>
  );
};

export default DataTableServerPagination;
